<template>
  <div class="order-conform">
    <div class="dialog-content">
      <p>
        Bedankt voor uw offerteaanvraag.<br />
        U ontvangt van ons zo spoedig mogelijk een reactie.
      </p>

      <div class="footer-menu">
        <button class="pill-button" @click="close">
          Sluiten
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { useFileListStore } from '@/stores/FileList.store'

export default {
  props: ['saveFilesOption'],
  data() {
    return {}
  },
  methods: {
    close() {
      const fileListStore = useFileListStore()
      fileListStore.clear()
      this.$emit('close')
      this.$router.push({ name: 'home' })

      this.rootStore.setHome()
    }
  }
}
</script>

<style lang="scss" scoped></style>
